/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { useMemo } from 'react';
import 'reflect-metadata';
import '@fontsource/source-sans-pro';
import App from './App';
import { createAppTheme } from './theme';
import { ThemeModeProvider, useThemeMode } from './contexts/ThemeModeContext';
// import './registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const AppRoot = () => {
  const { mode } = useThemeMode();
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <BrowserRouter basename="/">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          preventDuplicate
          disableWindowBlurListener
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={3000}
        >
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <AppRoot />
    </ThemeModeProvider>
  </React.StrictMode>
);
